<template>
  <div
    v-if="navList.length > 0"
    class="content-list"
  >
    <div class="container">
      <div class="left-container">
        <el-scrollbar style="height: 100%">
          <div
            v-for="(item,index) in navList"
            :key="item.catalogId"
            :class="['item-title', index == navIndex && 'item-title-active']"
            @click="navIndex = index"
          >
            <div class="item-bg" />
            <span>{{ item.name }}</span>
          </div>
        </el-scrollbar>
      </div>
      <div
        class="right-container"
      >
        <div
          v-show="cp_contentList.length > 1"
          ref="contentTitleContainer"
          class="content-title-list"
          @wheel="onWheel"
        >
          <div
            v-for="item in cp_contentList"
            :key="item.contentId"
            ref="contenTitleList"
            :class="['content-title', item.contentId == currentContentId && 'content-title-active']"
            @click="onClickContentTitle(item)"
          >
            <span>{{ item.title }}</span>
          </div>
        </div>
        <div
          v-show="!isEmpty"
          v-loading="contentLoading"
          style="width: 100%; flex: 1; overflow: hidden; display: flex; flex-direction: column"
        >
          <div
            v-if="cp_contentList.length < 2 && content[currentContentId]"
            class="content-one-title"
          >
            {{ content[currentContentId].title }}
          </div>
          <div
            v-if="content[currentContentId] && content[currentContentId].contentType == 0"
            class="richtext-container"
            v-html="content[currentContentId].content"
          />
          <iframe
            v-if="content[currentContentId] && content[currentContentId].contentType == 1"
            :src="content[currentContentId].contentLink"
            frameborder="0"
            style="width: 100%; height: 100%"
            @load="contentLoading = false"
          />
          <div
            v-if="content[currentContentId] && content[currentContentId].contentType == 2"
            class="video-container"
          >
            <div class="video-content">
              <video-play
                ref="player"
                :video-url="content[currentContentId].contentVideo"
                :video-name="content[currentContentId].title"
                video-width="100%"
                video-height="100%"
              />
              <div
                v-if="content[currentContentId].contentVideoImage && !content[currentContentId].isPlayed"
                class="video-cover"
              >
                <template v-if="!content[currentContentId].isPlayed">
                  <img
                    :src="content[currentContentId].contentVideoImage"
                    @click="$refs.player.playOrPause(); content[currentContentId].isPlayed = true;"
                  >
                  <img
                    src="@/assets/icon/ic_play.png"
                    class="icon-play"
                  >
                </template>
              </div>
            </div>
            <div :class="['video-describe', cp_contentList.length < 2 && 'video-describe-4line']">
              {{ content[currentContentId].describe }}
            </div>
          </div>
        </div>
        <div
          v-if="isEmpty"
          class="empty"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../proxy';
export default {
    name: 'ContentList',
    data () {
        return {
            navList: [],
            navIndex: 0,
            contentList: [],
            content: {},
            currentContentId: '',
            contentLoading: false,
            isEmpty: false,
        };
    },
    computed: {
        docmentHidden () {
            return this.$store.getters['system/getDocmentHidden'];
        },
        cp_contentList () {
            if (this.navList.length === 0) return [];
            const catalogId = this.navList[this.navIndex].catalogId;
            return this.contentList.filter(itm => +itm.catalogId === +catalogId);
        },
    },
    watch: {
        docmentHidden (val) {
            if (val) {
                if (this.$refs.player && this.$refs.player.isPlaying) {
                    this.$refs.player.playOrPause();
                }
            }
        },
        navIndex (val) {
            if (this.$refs.player && this.$refs.player.isPlaying) {
                this.$refs.player.playOrPause();
                this.content[this.currentContentId].seek = this.$refs.player.timeInfo.currentTime;
            }
            this.$nextTick(() => {
                if (this.cp_contentList.length) {
                    this.onClickContentTitle(this.cp_contentList[0]);
                    this.$refs.contentTitleContainer && (this.$refs.contentTitleContainer.scrollLeft = 0);
                }
            });
        },
        'cp_contentList.length': {
            handler (val) {
                this.isEmpty = val === 0;
            },
            immediate: true,
        },
    },
    async mounted () {
        const { siteId, catalogId } = this.$route.query;
        if (!siteId || !catalogId) return;
        const res1 = await api.contentPageList({ siteId, catalogId, subContent: 1, pageNo: 1, pageSize: 999 });
        if (res1.errcode === 0) {
            this.contentList = res1.data.list;
        } else {
            this.$message.error(res1.errmsg);
        }
        if (this.contentList.length === 0) return;
        const res2 = await api.getTreeList({ siteId, isShowDisable: 0, pageNo: 1, pageSize: 999 });
        if (res2.errcode === 0) {
            const item = res2.data.value.catalogList.find(itm => +itm.catalogId === +catalogId);
            if (item) {
                for (const itm of item.children) {
                    if (itm.status === 1) {
                        this.navList.push({
                            catalogId: itm.catalogId,
                            name: itm.name,
                        });
                    }
                }
            }
            this.$nextTick(() => {
                if (this.cp_contentList.length) {
                    this.onClickContentTitle(this.cp_contentList[0]);
                }
            });
        } else {
            this.$message.error(res2.errmsg);
        }
    },
    beforeDestroy () {
        if (this.$refs.player && this.$refs.player.isPlaying) {
            this.$refs.player.playOrPause();
        }
    },
    methods: {
        onWheel (e) {
            const target = e.currentTarget;
            /* if (target.offsetWidth < target.scrollWidth) {
                if (e.wheelDelta < 0 && target.scrollLeft + target.offsetWidth < target.scrollWidth) {
                    e.preventDefault();
                    e.stopPropagation();
                    target.scrollLeft += 100;
                } else if (e.wheelDelta > 0 && target.scrollLeft > 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    target.scrollLeft -= 100;
                }
            } */
            if (target.offsetWidth < target.scrollWidth) {
                e.preventDefault();
                e.stopPropagation();
                if (e.wheelDelta < 0) {
                    target.scrollLeft += 200;
                } else {
                    target.scrollLeft -= 200;
                }
            }
        },
        async onClickContentTitle (item) {
            if (this.currentContentId === item.contentId) return;
            this.contentLoading = true;
            if (this.currentContentId && this.content[this.currentContentId] && this.content[this.currentContentId].contentType === 2) {
                if (this.$refs.player) {
                    if (this.$refs.player.isPlaying) {
                        this.$refs.player.playOrPause();
                    }
                    this.content[this.currentContentId].seek = this.$refs.player.timeInfo.currentTime;
                }
            }
            if (!this.content[item.contentId]) {
                const res = await api.contentDetail({ contentId: item.contentId });
                if (res.errcode === 0) {
                    const temp = this.contentList.find(itm => +itm.contentId === +item.contentId);
                    this.$set(this.content, item.contentId, Object.assign(res.data, {
                        title: temp.title,
                        describe: temp.content,
                        isPlayed: false,
                        seek: 0,
                    }));
                } else {
                    this.$message.error(res.errmsg);
                }
            }
            setTimeout(() => {
                this.contentLoading = false;
            }, this.content[item.contentId].contentType === 1 ? 3000 : 60);

            this.currentContentId = item.contentId;
            setTimeout(() => {
                if (this.content[item.contentId].contentType === 2) {
                    this.$refs.player.setCurrentTime(this.content[item.contentId].seek);
                }
                const index = this.cp_contentList.findIndex(itm => +itm.contentId === +this.currentContentId);
                if (index > -1) {
                    const containerRect = this.$refs.contentTitleContainer.getBoundingClientRect();
                    const titleRect = this.$refs.contenTitleList[index].getBoundingClientRect();
                    this.$refs.contentTitleContainer.scrollLeft += (titleRect.width * 0.5 + titleRect.left) - (containerRect.width * 0.5 + containerRect.left);
                }
            }, 100);
        },
    },
};
</script>

<style scoped lang="scss">
.content-list {
    width: 100%;
    padding: 40px 0;
    .container {
        width: 1300px;
        height: 680px;
        margin: 0 auto;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        //::v-deep .el-tabs--left .el-tabs__nav.is-left, .el-tabs--left .el-tabs__nav.is-right, .el-tabs--right .el-tabs__nav.is-left, .el-tabs--right .el-tabs__nav.is-right {
        //    height: 100%;
        //    min-height: 690px;
        //    overflow: hidden;
        //}
        .left-container {
            width: 380px;
            height: 100%;
            background: #EBF1FF;
            border-radius: 12px;
            padding: 12px 0;
            .item-title {
                width: 100%;
                height: 70px;
                overflow: hidden;
                display: flex;
                align-items: center;
                color: #141414;
                font-size: 16px;
                cursor: pointer;
                user-select: none;
                position: relative;
                &.item-title-active {
                    .item-bg {
                        transform: translateX(0%);
                    }
                }
                &:hover {
                    .item-bg {
                        transform: translateX(0%);
                    }
                }
                .item-bg {
                    position: absolute;
                    z-index: 0;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0.8) 60%, rgba(255,255,255,0) 100%);
                    transform: translateX(-100%);
                    transition: transform 0.3s;
                }
                >img {
                    margin: 0 20px;
                    z-index: 1;
                }
                >span {
                    margin-left: 20px;
                    margin-right: 20px;
                    line-height: 20px;
                    flex: 1;
                    white-space: nowrap; /* 防止文本换行 */
                    overflow: hidden; /* 隐藏溢出的内容 */
                    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
                    z-index: 1;
                }
            }
        }
        .right-container {
            width: 900px;
            height: 100%;
            background: linear-gradient(180deg, #EBF1FF 0%, #F7F9FF 100%);
            border-radius: 12px;
            border: 2px solid #E0EAFF;
            padding: 20px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            .content-title-list {
                width: 100%;
                padding-bottom: 20px;
                overflow: hidden;
                scroll-behavior: smooth;
                white-space: nowrap;
                user-select: none;
                .content-title {
                    margin-right: 20px;
                    white-space: nowrap;
                    color: #1252FF;
                    font-weight: 500;
                    font-size: 16px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    height: 40px;
                    min-width: 120px;
                    max-width: 250px;
                    padding: 0 22px;
                    background-image: linear-gradient(90deg, #fff, #fff);
                    border-radius: 4px;
                    cursor: pointer;
                    transition: background-image 0.3s, color 0.2s;
                    overflow: hidden;
                    >span {
                        width: 100%;
                        text-align: center;
                        white-space: nowrap; /* 防止文本换行 */
                        overflow: hidden; /* 隐藏溢出的内容 */
                        text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
                    }
                    &:last-child {
                        margin-right: 0px;
                    }
                    &.content-title-active {
                        color: #FFFFFF;
                        background-image: linear-gradient(270deg, #5FB2FC, #317AF7);
                    }
                    &:hover {
                        color: #FFFFFF;
                        background-image: linear-gradient(270deg, #5FB2FC, #317AF7);
                    }
                }
            }
            .content-one-title {
                width: 100%;
                color: #141414;
                font-size: 16px;
                font-weight: 500;
                white-space: nowrap; /* 防止文本换行 */
                overflow: hidden; /* 隐藏溢出的内容 */
                text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
                flex-shrink: 0;
                margin-bottom: 20px;
            }
            .richtext-container {
                width: 100%;
                height: 100%;
                overflow-y: auto;
                &::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                &::-webkit-scrollbar-thumb {
                    background: rgba(0,0,0,0);
                }
                &:hover {
                    &::-webkit-scrollbar {
                        width: 6px;
                        height: 6px;
                        cursor: auto;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: rgba(0,0,0,0.1);
                        border-radius: 6px;
                        cursor: auto;
                    }
                }
            }
            .video-container {
                width: 100%;
                height: 100%;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                .video-content {
                    width: 100%;
                    height: 480px;
                    position: relative;
                    .video-cover {
                        position: absolute;
                        cursor: pointer;
                        left: 0;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        >img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                        .icon-play {
                            position: absolute;
                            pointer-events: none;
                            width: 50px;
                            height: 50px;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
                .video-describe {
                    width: 100%;
                    margin-top: 24px;
                    font-size: 14px;
                    line-height: 22px;
                    color: #676769;
                    overflow: hidden;
                    display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
                    -webkit-line-clamp: 3; /* 行数，值可以改，表示展示X行后多余的缩略展示 */
                    -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
                    word-break: break-all;
                    &.video-describe-4line {
                        -webkit-line-clamp: 4;
                    }
                }
            }
            .empty {
                width: 100%;
                height: 100%;
                background-image: url("~@/assets/image/no_data.png");
                background-size: 326px 241px;
                background-repeat: no-repeat;
                background-position: center center;
            }
        }
    }
    ::v-deep .el-loading-spinner .path {
        stroke: #409EFF;
    }
}
</style>
